import type { SedrRoomDetail, SedrRoomSummary } from '../../api/sedr';
import { isSedrRoomReadOnly } from './sedrUi';

export function isSedrAdmin(permission: string | null | undefined): boolean {
  return permission === 'Admin';
}

export function canSedrWrite(permission: string | null | undefined): boolean {
  return permission === 'Admin' || permission === 'Contributor';
}

/** Admins may manage members/guests on archived rooms; PendingDeletion still blocks. */
export function canSedrManageAccess(room: Pick<SedrRoomDetail, 'canManageMembers' | 'lifecycleState' | 'archivedAt'>): boolean {
  return Boolean(room.canManageMembers) && room.lifecycleState !== 'PendingDeletion';
}

export function canSedrMutateContent(
  room: Pick<SedrRoomSummary, 'permission' | 'lifecycleState' | 'archivedAt'>,
): boolean {
  return canSedrWrite(room.permission) && !isSedrRoomReadOnly(room.lifecycleState, room.archivedAt);
}

export function canSedrAdminActions(
  room: Pick<SedrRoomSummary, 'permission' | 'lifecycleState' | 'archivedAt'>,
): boolean {
  return isSedrAdmin(room.permission) && !isSedrRoomReadOnly(room.lifecycleState, room.archivedAt);
}
